import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ReceiveOrderRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.receiver_order_create === true ||
    permissions.receiver_order_edit === true ||
    permissions.receiver_order_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default ReceiveOrderRouteMiddleware;
